function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 96 96"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M25.949 66.908l41.337-41.337 3.564 3.563-41.338 41.338z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.956 29.142l3.563-3.564 41.338 41.337-3.564 3.564z"
})));